import { all, call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    GET_MY_MISSION_REQUESTS_REQUEST,
    GET_MISSION_REQUEST_REQUEST,
    CREATE_MISSION_REQUEST_REQUEST,
    CANCEL_MISSION_REQUEST_REQUEST,
    GET_MANAGER_MISSION_INBOX_REQUEST,
    MANAGER_MISSION_DECISION_REQUEST,
    GET_MANAGER_MISSION_HISTORY_REQUEST,
    GET_ADMIN_MISSION_INBOX_REQUEST,
    ADMIN_MISSION_DECISION_REQUEST,
    GET_ADMIN_MISSION_HISTORY_REQUEST,
    GET_ALL_MISSION_REQUESTS_REQUEST,

    setMissionRequestLoading,
    getMyMissionRequestsSuccess,
    getMyMissionRequestsFail,
    getMissionRequestSuccess,
    getMissionRequestFail,
    createMissionRequestSuccess,
    createMissionRequestFail,
    cancelMissionRequestSuccess,
    cancelMissionRequestFail,
    getManagerMissionInboxSuccess,
    getManagerMissionInboxFail,
    managerMissionDecisionSuccess,
    managerMissionDecisionFail,
    getManagerMissionHistorySuccess,
    getManagerMissionHistoryFail,
    getAdminMissionInboxSuccess,
    getAdminMissionInboxFail,
    adminMissionDecisionSuccess,
    adminMissionDecisionFail,
    getAdminMissionHistorySuccess,
    getAdminMissionHistoryFail,
    getAllMissionRequestsSuccess,
    getAllMissionRequestsFail, createMissionRequestForCollabFail, createMissionRequestForCollabSuccess,
} from "../actions/missionRequestActions";

import { API_BASE_URL, getRequest, postRequest } from "../../../api";

const extractErrorMessage = (error, fallback) => {
    const data = error?.response?.data;

    if (data?.message) return String(data.message);
    if (data?.error) return String(data.error);
    if (error?.message) return String(error.message);

    try {
        if (data && typeof data === "object") return JSON.stringify(data);
    } catch {}
    return fallback;
};

// ===================== WORKERS =====================

export function* getMyMissionRequestsSaga() {
    const url = `${API_BASE_URL}/api/mission-requests/requests/mine`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setMissionRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getMyMissionRequestsSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement demandes de mission");
        yield put(getMyMissionRequestsFail(msg));
    } finally {
        yield put(setMissionRequestLoading(false));
    }
}

export function* getMissionRequestSaga(action) {
    const id = action.payload;
    const url = `${API_BASE_URL}/api/mission-requests/requests/${id}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setMissionRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getMissionRequestSuccess(resp.data));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement demande");
        yield put(getMissionRequestFail(msg));
    } finally {
        yield put(setMissionRequestLoading(false));
    }
}

export function* createMissionRequestSaga(action) {
    const url = `${API_BASE_URL}/api/mission-requests/requests`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setMissionRequestLoading(true));
    try {
        const payload = action.payload;

        console.log("📤 Payload reçu:", payload);

        const requestData = {
            ordreMissionId: payload.ordreMissionId,
            motif: payload.motif || null,
            urgent: payload.urgent || false,
        };

        console.log("📦 Données de la demande:", requestData);

        const resp = yield call(postRequest, {
            url,
            token,
            data: requestData,
            headers: { uid },
        });

        console.log("✅ Demande créée:", resp.data);

        yield put(createMissionRequestSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Succès",
            text: "Demande de mission envoyée avec succès",
            timer: 1800,
            showConfirmButton: false,
        });

        yield put({ type: GET_MY_MISSION_REQUESTS_REQUEST });

    } catch (error) {
        console.error("❌ Erreur création demande:", error);
        console.error("❌ Response:", error?.response?.data);
        console.error("❌ Status:", error?.response?.status);

        const msg = extractErrorMessage(error, "Erreur création demande de mission");
        yield put(createMissionRequestFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setMissionRequestLoading(false));
    }
}

export function* cancelMissionRequestSaga(action) {
    const id = action.payload;
    const url = `${API_BASE_URL}/api/mission-requests/requests/${id}/cancel`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setMissionRequestLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            headers: { uid },
        });

        yield put(cancelMissionRequestSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Succès",
            text: "Demande annulée avec succès",
            timer: 1800,
            showConfirmButton: false,
        });

        yield put({ type: GET_MY_MISSION_REQUESTS_REQUEST });

    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur annulation demande");
        yield put(cancelMissionRequestFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setMissionRequestLoading(false));
    }
}

export function* getManagerMissionInboxSaga() {
    const url = `${API_BASE_URL}/api/mission-requests/manager/inbox`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setMissionRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getManagerMissionInboxSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement inbox manager");
        yield put(getManagerMissionInboxFail(msg));
    } finally {
        yield put(setMissionRequestLoading(false));
    }
}

export function* managerMissionDecisionSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const { id, decision, comment } = action.payload || {};
    const url = `${API_BASE_URL}/api/mission-requests/manager/requests/${id}/decision`;

    yield put(setMissionRequestLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: { decision, comment },
            headers: { uid },
        });

        yield put(managerMissionDecisionSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Décision envoyée",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: GET_MANAGER_MISSION_INBOX_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur décision manager");
        yield put(managerMissionDecisionFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setMissionRequestLoading(false));
    }
}

export function* getManagerMissionHistorySaga() {
    const url = `${API_BASE_URL}/api/mission-requests/manager/history`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setMissionRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getManagerMissionHistorySuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement historique manager");
        yield put(getManagerMissionHistoryFail(msg));
    } finally {
        yield put(setMissionRequestLoading(false));
    }
}

export function* getAdminMissionInboxSaga() {
    const url = `${API_BASE_URL}/api/mission-requests/admin/inbox`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setMissionRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getAdminMissionInboxSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement inbox RH");
        yield put(getAdminMissionInboxFail(msg));
    } finally {
        yield put(setMissionRequestLoading(false));
    }
}

export function* adminMissionDecisionSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const { id, decision, comment } = action.payload || {};
    const url = `${API_BASE_URL}/api/mission-requests/admin/requests/${id}/decision`;

    yield put(setMissionRequestLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: { decision, comment },
            headers: { uid },
        });

        yield put(adminMissionDecisionSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Décision RH envoyée",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: GET_ADMIN_MISSION_INBOX_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur décision RH");
        yield put(adminMissionDecisionFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setMissionRequestLoading(false));
    }
}

export function* getAdminMissionHistorySaga() {
    const url = `${API_BASE_URL}/api/mission-requests/admin/history`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setMissionRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getAdminMissionHistorySuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement historique admin");
        yield put(getAdminMissionHistoryFail(msg));
    } finally {
        yield put(setMissionRequestLoading(false));
    }
}

export function* getAllMissionRequestsSaga() {
    const url = `${API_BASE_URL}/api/mission-requests/admin/all`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setMissionRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getAllMissionRequestsSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement toutes les demandes");
        yield put(getAllMissionRequestsFail(msg));
    } finally {
        yield put(setMissionRequestLoading(false));
    }
}

export function* createMissionRequestForCollabSaga(action) {
    const url = `${API_BASE_URL}/api/mission-requests/manager/create-for-collab`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setMissionRequestLoading(true));
    try {
        const payload = action.payload;

        console.log("📤 Création demande pour collaborateurs:", payload);

        const resp = yield call(postRequest, {
            url,
            token,
            data: payload,
            headers: { uid },
        });

        console.log("✅ Demandes créées:", resp.data);

        yield put(createMissionRequestForCollabSuccess(resp.data));

        const count = payload.collaborateurIds?.length || 0;
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Succès",
            text: `${count} demande${count > 1 ? 's' : ''} créée${count > 1 ? 's' : ''} avec succès`,
            timer: 2000,
            showConfirmButton: false,
        });

        // Recharger la liste des demandes si nécessaire
        // yield put({ type: GET_MY_MISSION_REQUESTS_REQUEST });

    } catch (error) {
        console.error("❌ Erreur création demandes:", error);
        const msg = extractErrorMessage(error, "Erreur lors de la création des demandes");
        yield put(createMissionRequestForCollabFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: msg,
            timer: 2500,
            showConfirmButton: false,
        });
    } finally {
        yield put(setMissionRequestLoading(false));
    }
}
